import { render } from "./ReasonPrompt.vue?vue&type=template&id=a9d3980a"
import script from "./ReasonPrompt.vue?vue&type=script&lang=js"
export * from "./ReasonPrompt.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__